import { WEBSOCKET_FAILED_EVENT } from "constants/events";
import { useEffect } from "react";
import { useStompClient } from "react-stomp-hooks";
import { StompFilter } from "./StompComponent";

export type SubscriptionInfos = {
  subbedEvent: string;
  pathFilter?: string;
  filters?: StompFilter[];
};

interface Props {
  subscriptionInfo: SubscriptionInfos;
  handleWSError: (wsError: any) => void;
}

const SUBSCRIPTION_DESTINATION = "/to-applicat/events/subscribe";

export function SubscriptionSocket({
  subscriptionInfo,
  handleWSError,
}: Props) {
  let messageSent = false;
  const stompClient = useStompClient();
  const eventSub = {
    eventType: subscriptionInfo.subbedEvent,
    jsonPathFilter: subscriptionInfo.pathFilter,
    filters: subscriptionInfo.filters,
  };

  const sendMessage = () => {
    if (stompClient) {
      stompClient.publish({
        destination: SUBSCRIPTION_DESTINATION,
        body: JSON.stringify(eventSub),
      });
    } else {
      handleWSError({ event: { type: WEBSOCKET_FAILED_EVENT }, data: { message: "WebSocket Subscription Error:" + subscriptionInfo.subbedEvent, code: "EVTSUB001" } });
    }
  };

  useEffect(() => {
    if (!messageSent) { 
      sendMessage();
      messageSent = true;
    }
  }, []);

  return null;
}
